/** @format */

import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import LabelInput from "../../../../shared/components/labelInput";
import QuoteStep from "../../enums/QuoteStep";
import quoteUpdateMapper from "../../mappers/quoteUpdateMapper";
import {
  EditQuoteDetails,
  handleNext,
} from "../../../../shared/utils/navigationUtils";
import { fetchPanelData, saveQuote } from "../../services/quoteService";
import useQuoteStore from "../../store/QuoteStore";
import { useNavigate } from "fusion-plugin-react-router";
import {
  fetchVehCover,
  volentryExcess,
} from "../../../../shared/services/simpleListItemsService";
import RadioGroup from "../../../../shared/components/RadioGroup";

const TqPanelUpdate = ({ watch2, STATE }) => {
  const {
    register,
    formState: { errors },
    watch,
    handleSubmit,
    control,
    trigger,
  } = useForm({
    defaultValues: quoteUpdateMapper.get(),
  });

  const [optionsExcess, setOptionsExcess] = useState([]);
  const [coverLevel, setCoverLevel] = useState([]);
  const navigate = useNavigate();

  const convertArrayFormat = (array) => {
    if (!Array.isArray(array)) {
      console.error("convertArrayFormat: Input is not an array");
      return [];
    }

    return array.map((item) => ({
      value: item.listItemId || "0",
      label: `£${item.listItemDescription || "00"}`,
    }));
  };

  const convertArrayFormat2 = (array) => {
    if (!Array.isArray(array)) {
      return [];
    }
    return array.map((item) => ({
      value: item.listItemId || item,
      label: item.listItemDescription || item.toString(),
    }));
  };

  const UpdateQuoteResults = async (data) => {
    quoteUpdateMapper.set(data);
    STATE.setShowModel(false);

    const quoteData = useQuoteStore.getState().quote;
    saveQuote(quoteData, navigate).then((data) => {
      fetchPanelData(null, data.risk.riskObjectId).then(() => {
        handleNext(QuoteStep.TQ_PANEL, STATE);
      });
    });
    handleNext(QuoteStep.TQ_PANEL_LOADER, STATE);
  };

  useEffect(() => {
    volentryExcess().then((statuses) => setOptionsExcess(statuses));
  }, []);

  useEffect(() => {
    fetchVehCover().then((statuses) => setCoverLevel(statuses));
  }, []);

  return (
    <>
      {STATE.currentStep === QuoteStep.TQ_PANEL && (
        <>
          <div className="addonsBody2">
            <div className="addonContent2">
              <h1 className="addonsStyle h1StyleCustomize">
                Customise your quote
              </h1>
              <div className="container form2">
                <div className="fields">
                  <form onSubmit={handleSubmit(UpdateQuoteResults)}>
                    <LabelInput
                      id="volAccess"
                      label="Voluntary Excess"
                      type="select"
                      placeholder="£0"
                      options={convertArrayFormat(optionsExcess)}
                      register={register("volAccess", {
                        required: "Required",
                      })}
                      errors={errors.volAccess}
                      watch={watch("volAccess")}
                      control={control}
                      trigger={trigger}
                    />
                    <LabelInput
                      id="coverLevel"
                      label="Cover Level"
                      type="select"
                      options={convertArrayFormat2(coverLevel)}
                      control={control}
                      placeholder="Select cover level"
                      register={register("coverLevel", {
                        required: true,
                      })}
                      errors={errors.coverLevel}
                      watch={watch("coverLevel")}
                      trigger={trigger}
                    />
                    {watch2("bonus")?.value > 1 && (
                      <RadioGroup
                        name="claimBonus"
                        mainLabel="Would you like to protect your no claims bonus?"
                        register={register}
                        errors={errors.claimBonus}
                      />
                    )}
                    <div className="saveDetails2">
                      <button type="submit" className="SaveDetailsBtn2">
                        Update Quote Results
                      </button>
                      <div className="EditbtnDiv">
                        <button
                          onClick={() => EditQuoteDetails()}
                          type="button"
                          className="editButton1"
                        >
                          Edit Quote Details
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default TqPanelUpdate;
